import React, { useState, useEffect, useRef } from "react";
import {View, Image, Text, Pressable,} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, minSize, maxSize, } from "rn-responsive-styles";
import applicationStyles from "../../styles/applicationStyles";
import DropdownArrow from "../../assets/images/dropdown_arrow.png";
import ModalAlert from "../../common/ModalAlert";
import { getAllVehiclesList, sendOtpApi, validateOtpWithToken} from "../../api/apiManager";
import { updateRcVerify,rcUpdateServiceRequest,rcUpdate,getServiceReq} from "../../api/serviceRequest";
import Loader from "../../common/Loader";
import { isEmpty, toLower, toUpper } from "lodash";
import CustomButton from "../../common/CustomButton";
import AsyncStorageFunc from "./../../utilities/asyncStorage";
import {jwtDecode} from "jwt-decode";
import CustomInput from "../../common/CustomInput";
import RootNavigation from "../../utilities/RootNavigation";
import { useOutletContext } from "react-router-dom";
import CountdownTimer from "../../common/CTimer.web";
import CImage from "../../common/CImage";
import CText from "../../common/CText";
import useStyles from "./RCUpdate_Styles";


export default function RCUpdate(props) {
  const { serviceRequestList } = useOutletContext()
  const otpPattern = /^\d{6}$/;
  const RCPATTERN = /(?=.*[A-Z])(?=.*\d)[A-Z\d^()]/;
  const styles = useStyles();
  const fileInputRef = useRef();
  const [loading, setLoading] = useState(false);
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [showSelection, setShowSelection] = useState(true);
  const [mobileOtpMsg, setMobileOtpMsg] = useState("");
  const [requestId, setRequestId] = useState("");
  const [fastagId, setFastagId] = useState("");
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [otp, setOtp] = useState("");
  const [chassisList, setchassisList] = useState([]);
  const [selectedChassis, setselectedChassis] = useState("");
  const [rcDropOpen, setRcDropOpen] = useState(false);
  const [frontfile, setFrontImage] = useState("");
  const [backImage, setBackImage] = useState("");
  const [previewBackImage, setPreviewBackImage] = useState("");
  const [previewFrontImage, setPreviewFrontImage] = useState("");
  const counterRef = useRef(null);
  const [rcNumber, setRcNumber] = useState("");
  const [enableSubmmit, setEnableSubmit] = useState("");
  const [allowRcUpdate, setAllowRcUpate] = useState(true);
  const [alertModal, setAlertModal] = useState({ title: "", status: "", message: "",  navigateScreen: "",actionButton: "",});
  const [srList,setSrList] = useState([])
  useEffect(() => {
    if (props?.data) {
      setselectedChassis(props?.data.vrn); setFastagId(props?.data.fastagId); setShowSelection(false);
    } else {
      setselectedChassis(""); setFastagId(""); setShowSelection(true); onReset();
    }
  }, [props?.data]);

  useEffect(() => {
    if (frontfile) {
      let reader = new FileReader();
      reader.onloadend = () => {setPreviewFrontImage(reader.result);};
      console.log("file", frontfile);
      reader.readAsDataURL(frontfile);
    }

    if (backImage) {
      let reader = new FileReader();
      reader.onloadend = () => { setPreviewBackImage(reader.result);};
      reader.readAsDataURL(backImage);
    }
    if (frontfile && backImage && rcNumber != "" && selectedChassis != "") setEnableSubmit(true);
    else setEnableSubmit(false);
  }, [frontfile, backImage]);

  const toggleDropdownVrn = () => setRcDropOpen(!rcDropOpen);

  const onCloseModal = () => {
    setAlertModalVisible(false);
    if (alertModal.status == "success") {RootNavigation.navigate("serviceRequest") }
  };

  const handleItemClickRC = (chassis, vrn, fastag) => {
    setShowSelection(false);
    setRcDropOpen(false);
    setselectedChassis(vrn);
    setFastagId(fastag);
    if (frontfile && backImage && rcNumber ) { 
      setEnableSubmit(true)}
  };

  const onFrontimageChange = (event) => {
    const file = event.target.files[0];
    const maxFileSize = global?.maxUploadFileSizeInMB
    if (file) {
      var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      if (sizeInMB > maxFileSize) {
        setAlertModal({
          title: "Error",
          status: "error",
          message: `Kindly upload Jpeg images upto ${maxFileSize} MB`,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      } else if (file.type === "image/jpeg") {
        setFrontImage(file);
      } else {
        setFrontImage(null);
        setAlertModal({
          title: "Error",
          status: "error",
          message: "Kindly upload Jpeg  images only",
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      }} else {
      setFrontImage(null); }
  };

  const onBackimageChange = (event) => {
    const file = event.target.files[0];
    var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
    const maxFileSize = global?.maxUploadFileSizeInMB
    if (file) {
      if (sizeInMB > maxFileSize) {
        setAlertModal({
          title: "Error",
          status: "error",
          message: `Kindly upload Jpeg images upto ${maxFileSize} MB`,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      } else if (file.type == "image/jpeg") {
        setBackImage(file);
      } else {
        setBackImage(null);
        setAlertModal({
          title: "Error",
          status: "error",
          message: "Kindly upload Jpeg images only",
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      } } else {
      setBackImage(null); }
  };

  const handlefrontImageClick = (event) => {
    event.preventDefault();
    let element = document.getElementById("upload");
    element.click();
  };

  const onReset = () => {
    setFrontImage(null);
    setBackImage(null);
    setPreviewBackImage(null);
    setPreviewFrontImage(null);
    setselectedChassis("");
    setRcDropOpen(false);
    setRcNumber("");
    setShowSelection(true);
    setEnableSubmit(false);
  };

  const resendOTP = (params) => {
    setOtp("");
    setLoading(true);
    sendOtpApi(params)
      .then((res) => {
        setLoading(false);
        if (res?.statusCode === 1003) {
          setOtpData(res);
          setOtpModalVisible(true);
        }})
      .catch((err) => {
        setLoading(false);
        console.log(
          "<------------ error in send otp contact details api ----------->"
        );});
  };

  const handleBackImageClick = (event) => {
    event.preventDefault();
    let element = document.getElementById("uploadBack");
    element.click();
  };

  const getVehiclesList = () => {
    setLoading(true);
    getAllVehiclesList()
      .then((res) => {
        setLoading(false);
        if (res && !isEmpty(res)) {
          
          let temp  = res.filter((item) => {
            if( item.status !== "Closed by NPCI" && item.status !=="NPCI LB" ){
              return item
            }
            })
          setchassisList(temp);

        } console.log("chassis list", chassisList);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getVehiclesList();
    getSRList()
  }, []);

  const validateOTP = async () => {
    setLoading(true);
    let token = await AsyncStorageFunc.getData("TOKEN");
    let reqObj = {
      requestId: requestId,
      otp: otp,
      type: "updateRc",
      vrn: rcNumber,
      chasisNo: selectedChassis,
      userId: token ? jwtDecode(token).mappedOrgId : "",
    };
    validateOtpWithToken(reqObj)
      .then((res) => {
        setLoading(false);
        setOtp("");
        if ( res.statusCode == 200 || res.statusCode == 1011 || res.statusCode == 1012 || res.statusCode == 1013
        ) {
          setAlertModal({
            title: "Successful",
            status: "success",
            message: res.message,
            navigateScreen: "HomeScreen",
            actionButton: "OK",
          });
          setOtpModalVisible(false);
          setAlertModalVisible(true);
          onReset();
        } else if ( res.statusCode < 0 || res.statusCode == 500 || res.statusCode == -1003 ||res.statusCode == -1008) {
          setLoading(false);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setOtpModalVisible(false);
          setAlertModalVisible(true);
        } })
      .catch((err) => {
        setLoading(false);
        setAlertModal({ title: "Error", status: "error", message: err.message,navigateScreen: "",actionButton: "OK",});
        setAlertModalVisible(true);
        setOtpModalVisible(false);
      });
  };

  const verifyRcUpdate = () => {
    if (!RCPATTERN.test(toUpper(rcNumber))) {
      setAlertModal({ title: "Error", status: "error", message: "Please enter valid Vehicle number", navigateScreen: "", actionButton: "OK",});
      return setAlertModalVisible(true);
    }
    setLoading(true);
    let params = {vehicleNo: rcNumber, chassis_number: selectedChassis, custId: global.userCd};
    updateRcVerify(params)
      .then((res) => {
        setLoading(false);
        console.log(res);
        if (res.statusCode == -1040 || res.statusCode == -1045 || res.statusCode == 500) {
          setAlertModal({ title: "Error", status: "error", message: res?.message, navigateScreen: "", actionButton: "OK",});
          setAlertModalVisible(true);
          onReset();
        } else {
          if (res?.data?.canRaiseServiceRequest) {serviceReuest(); } else if (res?.data?.canApplyRCUpdate) {
            updateRc(); }
        } })
      .catch((err) => {
        console.log("error in verify update rc"), err;
      });
  };

  const serviceReuest = async () => {
    setLoading(true);
    let token = await AsyncStorageFunc.getData("TOKEN");
    let VehNumberData = {vehicleNo: rcNumber, chassis_number: selectedChassis,};
    var decoded = token ? jwtDecode(token) : "";
    let uploadPayload = new FormData();
    uploadPayload.append("data", JSON.stringify(VehNumberData));
    uploadPayload.append("filetype", "RC");
    uploadPayload.append("frontfile", frontfile);
    uploadPayload.append("backfile", backImage);
    uploadPayload.append("id", decoded.mappedOrgId + "");
    rcUpdateServiceRequest(uploadPayload)
      .then((res) => {
        console.log(res);
        setLoading(false);
        if (res?.statusCode != 200) {
          setAlertModal({
            title: "Error", status: "error", message: res?.message, navigateScreen: "", actionButton: "OK",
          });
          setAlertModalVisible(true);
          onReset();
        } else {
          setAlertModal({ title: "Success", status: "success", message: res?.message, navigateScreen: "", actionButton: "OK", });
          setAlertModalVisible(true);
        }})
      .catch((err) => {
        console.log("error in serive request rc"), err;
      });
  };

  const updateRc = () => {
    setLoading(true);
    let params = {vehicleNo: rcNumber, chassis_number: selectedChassis, custId: global.userCd, };
    rcUpdate(params)
      .then((res) => {
        console.log(res);
        setLoading(false);
        if (res?.statusCode == -1040 || res.statusCode == 500) {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res?.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          onReset();
        } else if (res?.statusCode == 200) {
          setAlertModal({
            title: "Success",
            status: "success",
            message: res?.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        }
      })
      .catch((err) => {
        console.log("error in update rc"), err;
      });
  };

  const isRcUpdateAllowed = (param) => {
    let isAllowRcupdate = true;
    let arr  = srList.filter(item=>{
       return item.vrn == param  && item.status !="Rejected"})
    if(arr.length){
      isAllowRcupdate = false;
    }
    return isAllowRcupdate;
  };

  const getSRList = ()=>{
    getServiceReq()
      .then((response) => {
        if (response.data.length){
          let  records = response.data.filter(
            (item) => item?.requestType == "RC Update"
          )
          setSrList(records)
        }
      })
      .catch(() => { });
  }
  return (
    <View style={{ position: "relative", zIndex: 999,width:'100%' }}>
      <View style={styles.RCUpdate_FunctionalityContainer}>
        <View style={styles.RCUpdate_SelectVehicleColumn}> 
          <Text style={styles.RCUpdate_SelectVehicleTitle}>Select Vehicle</Text>
          <Text style={styles.RCUpdate_SelectVehicleSubtitle}> Choose a vehicle you need to update RC of</Text>
          {selectedChassis != "" && !showSelection ? (
            <View><View style={styles.selectedItemWrapper}>
                <CImage.CarIconRc></CImage.CarIconRc>
                <View style={{ paddingLeft: 15 }}>
                  <CText.selectedChasisText>  {selectedChassis} </CText.selectedChasisText>
                  <CText.fastagIdText>  {"FASTag#"} {fastagId}</CText.fastagIdText>
                </View>
              </View>
              <Pressable onPress={() => setShowSelection(true)}> 
                <CText.changeVehicleText >{"Change Vehicle"}</CText.changeVehicleText>
               </Pressable>
            </View>
          ) : (
            <View style={[styles.dropDownViewStyle, styles.dropDownViewStyleRC]}>
              {showSelection ? ( 
              <Pressable onPress={toggleDropdownVrn} style={ rcDropOpen ? styles.dropdownHeader : styles.dropdownHeaderHide }>
                  <Text style={applicationStyles.dropDownHeaderText}>{selectedChassis || "Select Vehicle"}  </Text>
                  <Image  source={DropdownArrow} style={applicationStyles.iconDropdown} />
                </Pressable>
              ) : null}
              <View style={ rcDropOpen ? styles.showDropdownRC : styles.hideDropdownRC } >
                {chassisList.map((item, index) => (
                  <Pressable onPress={() => {
                      if (isRcUpdateAllowed(item.vrn)) {
                        handleItemClickRC( item.chassisNo,item.vrn,item.fastagId);
                      } else {
                        console.log(item);
                        setAllowRcUpate(false);
                        setselectedChassis(item.vrn);
                      }
                    }}
                    key={index}
                    style={applicationStyles.listItems}>
                    <Text style={applicationStyles.listItem}>  {item.vrn} </Text>
                  </Pressable>
                ))}
              </View>
            </View> )}
        </View>
        <View style={styles.RCUpdate_UploadImageColumn}>
          <Text style={styles.RCUpdate_UploadImageTitle}>  {"Vehicle Update"} </Text>
          <Text style={styles.RCUpdate_UploadImageSubtitle}>
            {"Enter Vehicle Number"}{" "}
            <Text style={[ styles.RCUpdate_UploadImageSubtitle, { color: "#bd2d37" } ]} > </Text> {"upload the front and back Image of your RC"} </Text>
          <Text style={styles.KYCUpd_DocUploadContainer_col2_WarningText} > {`*Only .jpeg images upto ${global?.maxUploadFileSizeInMB}MB are supported`} </Text>
          <View style={styles.enterRcViewStyle}>
            <View style={styles.enterRcBodyViewStyle}>
              <View style={styles.rcViewStyle}>
                <Text style={styles.rcNumberTextStyle}>{"Vehicle Number"}</Text>
                <View style={styles.rcInputViewStyle}>
                  <CustomInput
                    value={rcNumber}
                    onValueChanged={(e) => setRcNumber(e.replace(/[^a-zA-Z0-9]/gi, "")) }
                    onBlur={() => { if (frontfile && backImage && rcNumber && selectedChassis != "") { setEnableSubmit(true);} else { setEnableSubmit(false); } }}
                    pattern={/[^a-zA-Z0-9]/gi}
                  />
                </View>
              </View>
              <View style={styles.RCUpdate_UploadImageContainer}>
                {previewFrontImage ? (
                  <Image source={previewFrontImage} style={styles.frontImagePrevStyle} />
                ) : (
                  <Pressable style={styles.RCUpdate_ImageUploader} onPress={handlefrontImageClick}>
                    <View style={styles.RCUpdate_ImageUploader_InnerContainer}>
                      <Text style={styles.RCUpdate_ImageUploader_PlusIcon}>  + </Text>
                      <Text style={styles.RCUpdate_ImageUploader_AddText}> {' Add Front Image'}</Text>
                    </View>
                  </Pressable>
                )}
                {/* <View> */}
                  <input type="file" onChange={onFrontimageChange} style={{ display: "none" }} id="upload" accept="image/*" ref={fileInputRef} />
                {/* </View> */}
                <Pressable style={styles.RCUpdate_ImageUploader} onPress={handleBackImageClick}>
                  {previewBackImage ? (<Image source={previewBackImage} style={styles.backImagePrevStyle} /> ) : (
                    <View style={styles.RCUpdate_ImageUploader_InnerContainer}>
                      <Text style={styles.RCUpdate_ImageUploader_PlusIcon}> +  </Text>
                      <Text style={styles.RCUpdate_ImageUploader_AddText}> {'Add Back Image'} </Text>
                    </View>
                  )}
                </Pressable>
             <input type="file"  onChange={onBackimageChange} style={{ display: "none" }} id="uploadBack"  accept="image/*" ref={fileInputRef}  />
              </View>
            </View>
            <View style={styles.horizontalLine} />
            <View style={styles.RCUpdate_UploadImageButtons}>
              <Pressable style={styles.RCUpdate_UploadImageSubmit}>
                <CustomButton  text={"Submit"} onPress={enableSubmmit ? verifyRcUpdate : null}  disable={!enableSubmmit} />
              </Pressable>
              <Pressable style={styles.RCUpdate_UploadImageReset}  onPress={onReset} >
                <Text style={styles.RCUpdate_UploadImageReset_Text}>Reset</Text>
              </Pressable>
            </View>
          </View>
        </View>
      </View>
      {otpModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <View style={styles.overlayContainer}>
            <View style={styles.overlay}>
              <View style={styles.overlayContentViewStyle}>
                <Text style={styles.enterOtpTextStyle}>{"Enter OTP"}</Text>
                <Text style={styles.otpDescTextStyle}>{mobileOtpMsg}</Text>
                <View style={{ alignSelf: "center" }}>
                  <CustomInput
                    value={otp}
                    onValueChanged={(e) => setOtp(e)}
                    style={styles.otpInputViewStyle}
                    maxLength={6}
                    pattern={/^\d{6}$/}
                    errorMessage={"Enter Valid OTP"}
                    type="number"
                    keyboardType="numeric"
                  />
                </View>
                <View style={styles.resendViewStyle}>
                <CountdownTimer requestOtp={otpModalVisible} onClickGetOtp={resendOTP} counterRef={counterRef} />
                </View>
                <View style={{   width: 123.5, height: 36, alignSelf: "center", }} >
                  <CustomButton text={"Submit"}  onPress={!otpPattern.test(otp) ? "" : validateOTP} disable={!otpPattern.test(otp) ? true : false} />
                </View>
              </View></View>
          </View>
        </View>) : null}
      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert title={alertModal.title} status={alertModal.status} message={alertModal.message} navigateScreen={alertModal.navigateScreen} actionButton={"OK"} onCloseModal={onCloseModal} />
        </View>) : null}
      {!allowRcUpdate ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert title={"Alert"} message={ "Your RC Update request for " + selectedChassis +  " is In Progress"} actionButton={"OK"} onCloseModal={() => { setselectedChassis("");  setRcDropOpen(false); setAllowRcUpate(true); }} />
        </View>
      ) : null}
      {loading && <Loader />}
    </View>
  );
}


